import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SearchCommunicatorService {
  private searchLocationRequestSubject = new Subject<any>();

  public searchLocationRequest$ = this.searchLocationRequestSubject.asObservable();

  private searchLocationResponseSubject = new Subject<any>();

  public searchLocationResponse$ = this.searchLocationResponseSubject.asObservable();

  setSearchLocationRequest(address: any) {
    this.searchLocationRequestSubject.next(address);
  }

  setSearchLocationResponse(address: any) {
    this.searchLocationResponseSubject.next(address);
  }
}
